import React from 'react';
import '../assests/css/spinner.css';

function LoadingSpinner() {
  return (
    <div className="back">
      <div className="loading-spinner">
      </div>
    </div>
  )
}

export default LoadingSpinner
